import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import type { ReactNode } from "react";
import { supabase } from "@/lib/supabase";

interface AdminGuardProps {
  children: ReactNode;
}

export default function AdminGuard({ children }: AdminGuardProps) {
  const [status, setStatus] = useState<"loading" | "authed" | "denied">(
    "loading"
  );

  useEffect(() => {
    let active = true;

    supabase.auth.getSession().then(({ data }) => {
      if (!data.session) {
        if (active) setStatus("denied");
        return;
      }

      supabase
        .from("profiles")
        .select("is_admin")
        .eq("id", data.session.user.id)
        .maybeSingle()
        .then(({ data: profile }) => {
          if (!active) return;
          if (profile?.is_admin) {
            setStatus("authed");
          } else {
            setStatus("denied");
          }
        })
        .catch(() => {
          if (active) setStatus("denied");
        });
    });

    return () => {
      active = false;
    };
  }, []);

  if (status === "loading") {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background-50">
        <i className="ri-loader-4-line animate-spin text-3xl text-primary-500"></i>
      </div>
    );
  }

  if (status === "denied") {
    return <Navigate to="/auth/login" replace />;
  }

  return <>{children}</>;
}